export default __webpack_public_path__ + "locales/es/EmptyView.json?hash=059926f5b1e5ce55a1d18636ad484ead";